export interface EnamadEmbed {
  href: string
  src: string
}

function getAttribute(attributes: string, name: string): string | undefined {
  const match = attributes.match(new RegExp(`(?:^|\\s)${name}\\s*=\\s*(?:"([^"]*)"|'([^']*)'|([^\\s>]+))`, 'i'))
  return (match?.[1] ?? match?.[2] ?? match?.[3])?.replace(/&amp;/gi, '&')
}

function trustedSealUrl(value: string | undefined, pathname: string): URL | undefined {
  if (!value) return

  try {
    const url = new URL(value)
    if (
      url.protocol !== 'https:'
      || url.hostname !== 'trustseal.enamad.ir'
      || url.port
      || url.username
      || url.password
      || url.pathname !== pathname
    ) return

    const id = url.searchParams.get('id')
    const code = url.searchParams.get('Code')
    if (!id || !/^\d+$/.test(id) || !code || !/^[a-z\d]+$/i.test(code)) return

    return url
  } catch {
    return
  }
}

export function parseEnamadEmbedCode(value: string): EnamadEmbed | undefined {
  const normalized = value.replace(/[‘’]/g, '"')
  const anchor = normalized.match(/<a\b([^>]*)>([\s\S]*?)<\/a\s*>/i)
  const image = anchor?.[2].match(/<img\b([^>]*)>/i)
  if (!anchor || !image) return

  const href = trustedSealUrl(getAttribute(anchor[1], 'href'), '/')
  const src = trustedSealUrl(getAttribute(image[1], 'src'), '/logo.aspx')
  if (!href || !src) return

  if (
    href.searchParams.get('id') !== src.searchParams.get('id')
    || href.searchParams.get('Code') !== src.searchParams.get('Code')
  ) return

  return { href: href.href, src: src.href }
}
